import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // The network is expected to be unreliable (§5.1), so a failed refetch
      // must never blank a screen that already has data.
      retry: 2,
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
  },
})
